<!-- section template -->
<template>
  <div :class="$style.reservationListSectionList">
    <BaseOrderListReservation :loading="loading" loading-text="取得預約記錄中..." :order-list="formatOrderList" class="d-xl-none" />
    <el-table
      v-loading="loading"
      element-loading-text="取得預約記錄中..."
      :data="orderList"
      class="isStyleBase isRowPointer mb-5 d-none d-xl-block"
      cell-class-name="isHiddenLabel"
      :class="$style.reservationList"
      @row-click="goToMemberReservationItem"
    >
      <el-table-column type="expand" label-class-name="isHiddenLabel">
        <template slot-scope="props">
          <!-- 下拉列表 -->
          <el-table :data="[...formatOrdersItemsList(props.row.orders.items, props.row)]" class="isStyleChildren">
            <!-- <el-table-column v-slot="{ row }">
              <p>{{ row }}</p>
            </el-table-column> -->
            <el-table-column v-slot="{ row }" label="" align="center" label-class-name="isHiddenLabel">
              <OrderReservationInfo :item="row" />
            </el-table-column>
            <el-table-column v-slot="{ row }" label="更多" width="80" align="center" label-class-name="isHiddenLabel">
              <el-dropdown :hide-on-click="false">
                <BaseButton event class="isStylePrimary isText" @click.stop.prevent>
                  <i class="fontello fontello-more fa-2x"></i>
                </BaseButton>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(dropdownItem, index) in orderDropdownList(row)" :key="`dropdownItem-${index}`" :class="dropdownItem.class" @click.native="dropdownItem.onClick()">
                    <span v-html="dropdownItem.text"></span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="訂單編號" label-class-name="isHiddenLabel">
        <span class="ls-sm">＃{{ row.displayId }}</span>
        <br />
        <span class="font-number fs-sm text-gray-2">{{ formatDate(row.created_at, 'yyyy/MM/dd') }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="寵物名稱" label-class-name="isHiddenLabel">
        <span>{{ formatPetName(row.orders.items) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="付款狀態" width="125" label-class-name="isHiddenLabel">
        <template v-if="row.paidDate">
          <span class="fs-sm text-gray-2">{{ formatDate(row.paidDate, 'yyyy/MM/dd EEE') }}</span>
          <br />
        </template>
        <span class="fs-sm text-gray-2">{{ formatPaymentMethod(row.paymentMethod) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="金額" width="125" label-class-name="isHiddenLabel">
        <span class="font-number">{{ formatPrice(priceTotal(row)) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="狀態" width="90" label-class-name="isHiddenLabel">
        <div class="fw-medium" :class="`text-${formatOrder(row).color}`">
          {{ formatOrder(row).title }}
        </div>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="更多" width="80" align="center" label-class-name="isHiddenLabel">
        <el-dropdown :hide-on-click="false">
          <BaseButton event class="isStylePrimary isText" @click.stop.prevent>
            <i class="fontello fontello-more fa-2x"></i>
          </BaseButton>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(dropdownItem, index) in orderDropdownList(row, true)" :key="`dropdownItem-${index}`" :class="dropdownItem.class" @click.native="dropdownItem.onClick()">
              <span v-html="dropdownItem.text"></span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import formatDate from '@utils/format-date'
import formatCurrency from '@utils/format-currency'
import { formatOrder, formatOrderJoin } from '@utils/format-order'
import { merchantComputed } from '@store/helpers'
import { orderIsCanPay, orderIsOffline, orderParamsList } from '@utils/ipetbooking-order'
import formatPrice from '@utils/format-price'
import { conditionList } from '@utils/is-condition'
import formatPaymentMethod from '@utils/format-payment-method'
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'

export default {
  name: 'ReservationListSectionList2',
  components: {
    OrderReservationInfo: () => import('@components/Order/OrderReservationInfo'),
  },
  props: {
    orderList: {
      type: Array,
      default: () => {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...merchantComputed,
    formatOrderList() {
      return this.orderList.map((containerItem) => {
        return {
          displayId: containerItem.displayId,
          head: [
            {
              title: '',
              titleClass: '',
              text: this.formatPetName(containerItem.orders.items),
              textClass: 'text-primary-dark fs-lg font-medium',
              class: '',
            },
            {
              title: '訂單狀態',
              titleClass: '',
              text: formatOrder(containerItem).title,
              textClass: `text-${formatOrder(containerItem).color}`,
              class: '',
            },
            {
              title: '訂單付款狀態',
              titleClass: '',
              text:
                (containerItem.paidDate ? `<span class="fs-sm">${formatDate(containerItem.paidDate, 'yyyy/MM/dd EEE')}</span>` : '') +
                `<span class="fs-sm text-gray-2 ml-2">${formatPaymentMethod(containerItem.paymentMethod)}</span>`,
              textClass: '',
              class: '',
            },
            {
              title: '總計',
              titleClass: '',
              text: formatPrice(this.priceTotal(containerItem)),
              textClass: '',
              class: '',
            },
          ],
          body: [
            ...this.formatOrdersItemsList(containerItem.orders.items, containerItem).map((orderItem) => {
              return {
                ...orderItem,
                foot: [
                  {
                    type: 'button',
                    text: '查看',
                    class: 'flex-grow-1',
                    buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
                    onClick: () => {
                      this.goToMemberReservationItem(orderItem)
                    },
                  },
                  {
                    type: 'dropdown',
                    text: '更多',
                    class: 'flex-grow-1',
                    buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
                    dropdown: this.orderDropdownList(orderItem),
                  },
                ],
              }
            }),
          ],
          foot: [
            {
              type: 'button',
              text: '查看',
              class: 'flex-grow-1',
              buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
              onClick: () => {
                this.goToMemberReservationItem(containerItem)
              },
            },
            {
              type: 'dropdown',
              text: '更多',
              class: 'flex-grow-1',
              buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
              dropdown: this.orderDropdownList(containerItem, true),
            },
          ],
        }
      })
    },
  },
  mounted() {},
  methods: {
    formatOrder,
    formatOrderJoin,
    orderIsCanPay,
    formatPrice,
    formatDate,
    formatCurrency,
    formatPaymentMethod,
    formatTextUpperCasefirst,
    goToMemberReservationItem(item) {
      let uuid = item.uuid
      if (item.containerDisplayId) {
        uuid = item.containerUuid
      }
      this.$router.push({
        name: 'member-reservation-item',
        params: {
          containerUuid: uuid,
        },
        query: {
          activeAlias: item.containerUuid ? item.id : undefined,
        },
      })
    },

    childrenOrderParamsList(order) {
      return orderParamsList({
        params: order.params,
      })
    },
    goToReservationUnpaidCheckout(order) {
      this.$router.push({
        name: 'reservation-unpaid-checkout',
        params: {
          containerUuId: order.containerUuid ? order.containerUuid : order.uuid,
        },
      })
    },
    goToPrepaidUnpaidCheckout(order) {
      this.$router.push({
        name: 'prepaid-unpaid-checkout',
        params: {
          storeType: order.params[0].store.storeType,
          prepaidAlias: order.prepaid.alias,
          orderId: order.prepaid.id,
        },
      })
    },
    goToReservationItem(order) {
      this.$router.push({
        name: 'reservation-item',
        params: {
          storeAlias: order.param.store.alias,
          reservationAlias: order.param.alias,
        },
      })
    },
    goToPrepaidCheckoutDetail(order) {
      this.$router.push({
        name: 'prepaid-checkout-detail',
        params: {
          orderId: order.id,
        },
      })
    },
    goToGoogleCalendar(orderItem) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = `[${this.currentMerchant.title}${orderItem.param.store.title}] ${orderItem.pet.name} - ${orderItem.param.title}` || ''
      const start = orderItem.startDate.replace(/-/g, '').replace(/:/g, '').replace(/\s/g, 'T')
      const end = orderItem.endDate.replace(/-/g, '').replace(/:/g, '').replace(/\s/g, 'T')
      const dates = `${start}/${end}`
      const details = orderItem.param.description || ''
      const location = orderItem.param.store.fullAddress
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`

      window.open(`http://www.google.com/calendar/event?${query}`)
    },
    showGoToPrepaidUnpaidCheckout(order) {
      const isPlanAliasAdvanced = this.currentMerchant.planAlias === 'advanced'
      const isUnpaid = order.paymentStatus === 'UNPAID'
      const isCanPay = orderIsCanPay(order.prepaid) && (order.prepaid?.paymentMethod === 'Credit' || order.prepaid?.paymentMethod === null)
      const isPrepaid = order.paymentMethod === 'Prepaid'

      return isPlanAliasAdvanced && isUnpaid && isCanPay && isPrepaid
    },
    showGoToPrepaidCheckoutDetail(order) {
      const isAdvanced = this.currentMerchant.planAlias === 'advanced'
      const isUnpaid = order.paymentStatus === 'UNPAID'
      const isCanPay = orderIsCanPay(order.prepaid) && (order.prepaid?.paymentMethod === 'Credit' || order.prepaid?.paymentMethod === null)
      const isPrepaid = order.paymentMethod === 'Prepaid'

      return isAdvanced && isUnpaid && !isCanPay && isPrepaid
    },
    openDialogContact(storeList) {
      this.$globalDialog('DialogContact', {
        storeList,
      })
    },
    isOffline(orderItem) {
      return orderIsOffline({
        order: orderItem,
        ordertype: 'order',
        type: 'reservation',
        isList: true,
      })
    },
    orderDropdownList(item, isMain = false) {
      return conditionList([
        {
          text: '前往付款',
          class: '',
          onClick: () => {
            this.goToReservationUnpaidCheckout(item)
          },
          condition: () => {
            return item.paymentStatus === 'UNPAID' && orderIsCanPay(item) && (item.paymentMethod === 'Credit' || item.paymentMethod === null)
          },
        },
        {
          text: `前往付款${this.currentMerchant?.prepaidSetting?.title || this.$t('site.PREPAID_TITLE')}`,
          class: '',
          onClick: () => {
            this.goToPrepaidUnpaidCheckout(item)
          },
          condition: () => {
            return this.showGoToPrepaidUnpaidCheckout(item)
          },
        },
        {
          text: `查看${this.currentMerchant?.prepaidSetting?.title || this.$t('site.PREPAID_TITLE')}訂單`,
          class: '',
          onClick: () => {
            this.goToPrepaidCheckoutDetail(item.prepaid)
          },
          condition: () => {
            return this.showGoToPrepaidCheckoutDetail(item)
          },
        },
        {
          text: '查看訂單',
          class: '',
          onClick: () => {
            this.goToMemberReservationItem(item)
          },
        },
        {
          text: '加入行事曆<i class="fal fa-external-link ml-2"></i>',
          class: '',
          onClick: () => {
            this.goToGoogleCalendar(item)
          },
          condition: () => {
            return item.status !== 0 && item.containerPaymentStatus !== 'UNPAID' && !isMain
          },
        },
        {
          text: '查看服務資訊',
          class: '',
          onClick: () => {
            this.goToReservationItem(item)
          },
          condition: () => {
            return !isMain
          },
        },
        {
          text: '聯繫我們',
          class: '',
          onClick: () => {
            this.openDialogContact([item.orders.items[0].param.store])
          },
        },
      ])
    },
    priceTotal(item) {
      const ordersListTotal = item.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0)
      const paramsListTotal = item.params.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.total
      }, 0)
      return ordersListTotal + paramsListTotal
    },
    formatOrdersItemsList(children, main) {
      return children.map((item) => {
        return {
          ...item,
          containerPaymentStatus: main.paymentStatus,
        }
      })
    },
    formatPetName(list) {
      let result = list
        .filter((item, index, self) => {
          return item.type === "cosmetic" && index === self.findIndex((t) => t.pet.id === item.pet.id)
        })
        .map((item) => {
          return item.pet.name
        })
        .join('、')
      if(!result){
        result = "-"
      }
      return result
    },
    // async tryToFetchUnPaidContainerList() {
    //   await this.$store.dispatch('merchant/fetchContainerList', {
    //     ,
    //   })
    //     .then(() => {
    //       return true
    //     })
    // }
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.reservationListSectionList {
  min-height: 532px;

  :global {
    .reservationListSectionList {
      &__dropdown {
        width: 100%;
        font-size: 1rem;
      }
    }
  }
}

.reservationList {
  min-height: 532px;
  :global {
    .reservationList {
      &__title {
        font-weight: 500;
      }

      &__date,
      &__meta {
        font-size: 0.75rem;
        color: $color-gray-2;
        letter-spacing: 0.1em;
      }
      &__petImg {
        width: 50px;
        height: 50px;
        background-color: #e4e7e9;
        background-image: url('~@assets/images/reservation/pet-avatar-default@2x.png');
        background-position: center;
        background-size: cover;
        border: 1px solid rgba($color-gray-4, 0.3);
        border-radius: 100%;
      }
      &__orderItemTopBox {
        padding-left: 45px;
      }
      &__orderItemBottomBox {
        padding-left: 45px;
      }
      &__orderItemHr {
        @include hr_decoration();
      }
    }

    // stylelint-disable selector-class-pattern
    .el-table__expand-column {
      padding: 0;

      > .cell {
        padding: 0;

        > .el-table__expand-icon {
          height: 95px;
        }
      }
    }

    // stylelint-enable selector-class-pattern
  }
}
</style>
